// Atribuire sursă comandă (first touch în sesiune) - sessionStorage, NU cookie, NU trimis către terți.
// Se salvează la prima pagină din sesiune și se trimite DOAR la crearea comenzii (câmp „attribution").
// Fără date personale: doar UTM, domeniul referrer-ului, path-ul de aterizare și dacă a existat gclid.

const KEY = 'cf_attribution';
const clip = (v) => (typeof v === 'string' ? v.trim().slice(0, 200) : '');

export const captureAttribution = () => {
  try {
    if (typeof window === 'undefined' || sessionStorage.getItem(KEY)) return; // doar prima atingere din sesiune
    const params = new URLSearchParams(window.location.search);
    let referrer = '';
    try {
      if (document.referrer) {
        const host = new URL(document.referrer).hostname.toLowerCase();
        if (host && host !== window.location.hostname) referrer = host; // ignorăm navigarea internă
      }
    } catch (e) { /* referrer invalid */ }

    const data = {
      source: clip(params.get('utm_source')),
      medium: clip(params.get('utm_medium')),
      campaign: clip(params.get('utm_campaign')),
      referrer: clip(referrer),
      landingPage: clip(window.location.pathname), // doar path, fără query
      hasGclid: params.has('gclid')
    };
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch (e) { /* sessionStorage indisponibil - fără atribuire */ }
};

export const getAttribution = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : undefined;
  } catch (e) {
    return undefined;
  }
};
